import { NavLink } from "react-router-dom";
import { Icons } from "../../assets/icons";
import LinkedIn from "../../assets/icons/Icon Placement.svg";
import RedirectPopup from "../redirectPopup";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
const NameCard = (props: {
  leader: {
    Name: string;
    Designation: string;
    Image: { url: string };
    LinkedIn: string;
  };
  type: string;
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 h-max">
      <div className="">
        <div className="flex md:w-24 w-full items-center justify-between">
          <img
            className="rounded-[8px] md:w-24 md:h-24 w-14 h-14 object-cover"
            src={`${process.env.REACT_APP_API_BASE_URL}${props.leader.Image.url}`}
            alt={props.leader.Name}
          />
          <RedirectPopup
            link={props.leader.LinkedIn}
            target="_blank"
            className="md:hidden"
            rel="noopener noreferrer"
            data-gtm-id="item-25"
            arialabel={`${props.leader.Name}'s LinkedIn profile (opens in new tab)`}
            content={
              <img
                src={LinkedIn}
                alt={`${props.leader.Name}'s LinkedIn profile (opens in new tab)`}
                className="h-10 w-10 md:hidden"
              />
            }
          />
        </div>
      </div>
      <div className="flex flex-col w-full h-full justify-between">
        <div>
          <div className="flex gap-2 items-center">
            <h4 className="text-lg font-bold">{props.leader.Name}</h4>

            <div className="hidden md:block min-w-6 hover:scale-105 hover:bg-bg-neutral_rose">
              <RedirectPopup
                link={props.leader.LinkedIn}
                target="_blank"
                className="h-8 w-8"
                rel="noopener noreferrer"
                arialabel={`${props.leader.Name}'s LinkedIn profile (opens in new tab)`}
                content={
                  <img
                    src={LinkedIn}
                    alt={`${props.leader.Name}'s LinkedIn profile (opens in new tab)`}
                  />
                }
              />
            </div>
          </div>

          <div className="leading-5">{props.leader.Designation}</div>
        </div>
        {/* <Sheet>
          <SheetTrigger>
            <div className="flex items-center font-bold gap-2 text-body-text-lilly_red cursor-pointer">
              Read Full Bio <Icons.ArrowRight />
            </div>
          </SheetTrigger>
          <SheetContent>
            <SheetHeader className="border-b border-border-gray20 text-left">
              <SheetTitle className="md:text-2xl text-xl">
                {props.type} Bio
              </SheetTitle>
            </SheetHeader>
            <div className="p-8">
              <div className="flex flex-col md:flex-row gap-4 h-max">
                <div className="">
                  <div className="flex md:w-24 w-full items-center justify-between">
                    <img
                      className="rounded-[8px] md:w-24 md:h-24 w-14 h-14 object-cover"
                      src={`${process.env.REACT_APP_API_BASE_URL}${props.leader.Image.url}`}
                      alt=""
                    />
                    <img
                      src={LinkedIn}
                      alt=""
                      className="h-10 w-10 md:hidden"
                    />
                  </div>
                </div>
                <div className="flex flex-col w-full h-full justify-between">
                  <div>
                    <div className="flex gap-2">
                      <div className="text-lg font-bold">
                        {props.leader.Name}
                      </div>
                      <img src={LinkedIn} alt="" className="hidden md:block" />
                    </div>

                    <div className="leading-5">{props.leader.Designation}</div>
                  </div>
                </div>
              </div>
              <div className="mt-4">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Odio
                neque eum quaerat velit sed ullam quidem voluptates! Labore
                nesciunt voluptates ipsam deserunt modi soluta et? Quos cum
                adipisci eos quaerat?
              </div>
            </div>
          </SheetContent>
        </Sheet> */}
      </div>
    </div>
  );
};

export default NameCard;
